<template>
  <div>
    <el-form-item :label="jumpLabel">
      <el-radio-group
        v-model="ruleForm.goShopSetting"
        :disabled="isDisabled"
        @change="onShopSetChange"
      >
        <el-radio :label="0">进入店铺首页</el-radio>
        <el-radio :label="1">跳转指定小程序</el-radio>
        <el-radio :label="2">进入指定链接</el-radio>
      </el-radio-group>
      <slot>
        <div style="color: #f56c6c" v-if="isShowTip">
          部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
        </div>
      </slot>
      
    </el-form-item>
    <div v-if="ruleForm.goShopSetting == 1">
      <el-form-item label="小程序appId:" :required="isRequired">
        <el-input
          type="textarea"
          placeholder="请输入小程序appId"
          style="width: 425px; margin-left: 8px"
          show-word-limit
          v-model="ruleForm.goShopAppId"
          :maxlength="1000"
          :disabled="isDisabled"
        ></el-input>
      </el-form-item>
      <el-form-item label="页面路径path:">
        <el-input
          type="textarea"
          placeholder="请输入小程序页面路径path"
          style="width: 425px; margin-left: 8px"
          show-word-limit
          v-model="ruleForm.goShopUrl"
          :maxlength="1000"
          :disabled="isDisabled"
        ></el-input>
        <div style="color: #f56c6c">
          注意：path若不写，则默认进入小程序主页。
        </div>
      </el-form-item>
    </div>
    <el-form-item label="指定链接:" required v-if="ruleForm.goShopSetting == 2">
      <el-input
        type="textarea"
        placeholder="请输入指定链接"
        style="width: 425px; margin-left: 8px"
        show-word-limit
        v-model="ruleForm.goShopUrl"
        :maxlength="1000"
        :disabled="isDisabled"
      ></el-input>
      <div style="color: #f56c6c">
        注意：仅可填写京东域内的
        H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
      </div>
    </el-form-item>
  </div>
</template>
<script>

export default {
  model: {
    prop: "ruleInfo",
    event: "ruleInfoUpdate",
  },
  props: {
    ruleInfo: {
      type: Object,
      default: () => {},
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    jumpLabel: {
        type: String,
        default: "进店逛逛:"
    },
    isShowTip: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {};
  },
  computed: {
    ruleForm: {
      get() {
        return this.ruleInfo;
      },
      set(val) {
        this.$emit("ruleInfoUpdate", val);
      },
    },
  },
  watch: {},
  mounted() {},
  methods: {
    onShopSetChange() {
      this.ruleForm.goShopAppId = "";
      this.ruleForm.goShopUrl = "";
    },
  },
};
</script>
<style lang="scss" scoped></style>
